__turbopack_context__.v({
  "marquee": "Marquee-module__umC5fq__marquee",
  "overlay": "Marquee-module__umC5fq__overlay",
  "root": "Marquee-module__umC5fq__root",
  "scroll": "Marquee-module__umC5fq__scroll",
});
